









import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

type DataType = {
	STREDNAKL_OZN: string;
	TEXT: string;
	PROVOZOVNA_ID: number;
	X_PROVOZOVNA_ID: number;
	STRNAKLTYP_OZN: string;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'STREDNAKL_OZN',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				provozovnaId: null,
				strnakltypOzn: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.STREDNAKL_OZN,
				text: data.TEXT,
				provozovnaId: data.PROVOZOVNA_ID,
				provozovnaIdText: data.X_PROVOZOVNA_ID,
				strnakltypOzn: data.STRNAKLTYP_OZN,
			};
		},
	},
});
